import { rgba } from 'polished'
import styled, { css } from 'styled-components'

const HAIRLINE = 'var(--color-line)'

export const LeftPanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 12px;
`

export const TabBar = styled.div`
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  padding: 4px;
  background: #ffffff;
  border: 1px solid ${HAIRLINE};
  border-radius: var(--radius-card);
`

export const Tab = styled.button`
  flex: 1;
  min-height: 48px;
  padding: 0 16px;
  border: none;
  border-radius: 10px;
  font-family: inherit;
  cursor: pointer;
  touch-action: manipulation;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition: background-color 0.12s, color 0.12s;
  background: transparent;
  color: ${({ theme }) => theme.colors.muted};

  &:active {
    background: ${({ theme }) => rgba(theme.colors.global, 0.06)};
  }

  ${({ active, theme }) => active && css`
    background: ${theme.colors.global};
    color: #ffffff;

    &:active {
      background: ${theme.colors.global};
    }
  `}
`

export const TabIcon = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.01em;
`

export const TabContent = styled.div`
  flex: 1;
  overflow: hidden;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const TopRow = styled.div`
  display: flex;
  gap: 12px;
  flex-shrink: 0;
  /* fixed height: nothing below moves when the last-scanned name wraps */
  height: 72px;
  align-items: stretch;
`

export const TopRowMain = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
`

export const TopRowAside = styled.div`
  flex: 0 0 46%;
  max-width: 520px;
  min-width: 0;
  display: flex;
`

export const CategoriesRow = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const CategoryChipInline = styled.button`
  flex: 1 1 auto;
  min-height: 48px;
  padding: 0 14px;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  white-space: nowrap;
  cursor: pointer;
  touch-action: manipulation;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  border: 1px solid ${HAIRLINE};
  background: #ffffff;
  color: ${({ theme }) => theme.colors.global};
  transition: background-color 0.12s, border-color 0.12s, color 0.12s;

  &:active {
    background: ${({ theme }) => rgba(theme.colors.global, 0.06)};
  }

  ${({ active, theme }) => active && css`
    background: ${theme.colors.global};
    border-color: ${theme.colors.global};
    color: #ffffff;

    &:active {
      background: ${theme.colors.global};
    }
  `}
`

export const WorkArea = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  gap: 12px;
`

export const KeypadColumn = styled.div`
  width: 216px;
  flex-shrink: 0;
  align-self: flex-start;
  padding: 8px;
  background: #ffffff;
  border: 1px solid ${HAIRLINE};
  border-radius: 14px;
`

export const ScrollContent = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding-bottom: 24px;
  /* soft fade so a clipped last row reads as "scroll for more" */
  mask-image: linear-gradient(to bottom, #000 calc(100% - 24px), transparent);
  -webkit-mask-image: linear-gradient(to bottom, #000 calc(100% - 24px), transparent);

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #D5DAE0;
    border-radius: 3px;
  }
`
